// Data updated with multiple reviews per course.
export const courseReviews = [
    // --- AE 241 - Aerodynamics ---
    {
      id: 2001,
      studentName: 'Kalpesh Khare',
      yearOfStudy: 'Third Year',
      courseName: 'AE 241 - Aerodynamics',
      courseCode: 'AE 241',
      semester: 'Autumn 2024',
      instructor: 'Dr. Viren I. Menezes',
      difficulty: 4,
      difficultyAspects: ['Concept heavy', 'Math-heavy'],
      effort: 'Very good',
      instructorRatings: { teachingStyle: 4, clarity: 5, studentInterest: 4, timeManagement: 4, approachability: 5, feedback: 3, },
      contentRatings: { clarity: 5, organization: 4, workload: 'Appropriate', participation: 4, },
      quizzes: '3',
      examDifficulty: 3,
      formulaSheetPolicy: 'Only in midsem/ endsem',
      usefulReferences: ['Slides', 'Reference books'],
      youtubePlaylist: 'NPTEL Aerodynamics by Prof. S.K. Som',
      assignmentFrequency: 'Weekly',
      assignmentDifficulty: 4,
      assignmentBrief: 'Assignments were challenging and required a deep understanding of the concepts. They were very helpful for exam preparation.',
      attendancePolicy: 'No, but would strongly suggest to attend',
      weightageDistribution: 'Quizzes: 20%, Midsem: 30%, Endsem: 50%',
      improvements: 'More in-class problem-solving sessions would be beneficial. The pace was a bit fast at times.',
    },
    {
      id: 2003, // New ID
      studentName: 'Riya Sharma',
      yearOfStudy: 'Third Year',
      courseName: 'AE 241 - Aerodynamics',
      courseCode: 'AE 241',
      semester: 'Autumn 2024',
      instructor: 'Dr. Viren I. Menezes',
      difficulty: 3,
      difficultyAspects: ['Concept heavy'],
      effort: 'Satisfactory',
      instructorRatings: { teachingStyle: 4, clarity: 4, studentInterest: 3, timeManagement: 5, approachability: 4, feedback: 4, },
      contentRatings: { clarity: 4, organization: 4, workload: 'Appropriate', participation: 3, },
      quizzes: '3',
      examDifficulty: 3,
      formulaSheetPolicy: 'Only in midsem/ endsem',
      usefulReferences: ['Slides', 'PYQs'],
      youtubePlaylist: '',
      assignmentFrequency: 'Weekly',
      assignmentDifficulty: 3,
      assignmentBrief: 'Assignments were manageable if you kept up with the lectures.',
      attendancePolicy: 'No, but would strongly suggest to attend',
      weightageDistribution: 'Quizzes: 20%, Midsem: 30%, Endsem: 50%',
      improvements: 'The reference book was not very useful; relying on slides is better.',
    },
    {
      id: 2004, // New ID
      studentName: 'Amit Patel',
      yearOfStudy: 'Third Year',
      courseName: 'AE 241 - Aerodynamics',
      courseCode: 'AE 241',
      semester: 'Autumn 2024',
      instructor: 'Dr. Viren I. Menezes',
      difficulty: 4,
      difficultyAspects: ['Math-heavy', 'Pace of teaching'],
      effort: 'Excellent',
      instructorRatings: { teachingStyle: 5, clarity: 5, studentInterest: 5, timeManagement: 4, approachability: 5, feedback: 3, },
      contentRatings: { clarity: 5, organization: 5, workload: 'Appropriate', participation: 4, },
      quizzes: '3',
      examDifficulty: 4,
      formulaSheetPolicy: 'Only in midsem/ endsem',
      usefulReferences: ['Reference books'],
      youtubePlaylist: 'MIT OCW on Fluid Dynamics',
      assignmentFrequency: 'Weekly',
      assignmentDifficulty: 4,
      assignmentBrief: 'The math in the assignments was tough but fair.',
      attendancePolicy: 'No, but would strongly suggest to attend',
      weightageDistribution: 'Quizzes: 20%, Midsem: 30%, Endsem: 50%',
      improvements: 'It would be great to have more tutorials for the math-heavy topics.',
    },
    // --- AE 405 - Propulsion ---
    {
      id: 2002,
      studentName: 'Priya Singh',
      yearOfStudy: 'Fourth Year',
      courseName: 'AE 405 - Propulsion',
      courseCode: 'AE 405',
      semester: 'Spring 2025',
      instructor: 'Dr. Sudarshan Kumar',
      difficulty: 5,
      difficultyAspects: ['Pace of teaching', 'Assignments'],
      effort: 'Excellent',
      instructorRatings: { teachingStyle: 5, clarity: 5, studentInterest: 5, timeManagement: 4, approachability: 4, feedback: 4, },
      contentRatings: { clarity: 5, organization: 5, workload: 'Appropriate', participation: 5, },
      quizzes: '>3',
      examDifficulty: 5,
      formulaSheetPolicy: 'No',
      usefulReferences: ['Slides', 'PYQs'],
      youtubePlaylist: '',
      assignmentFrequency: 'Bi-weekly',
      assignmentDifficulty: 5,
      assignmentBrief: 'Assignments were very tough but crucial for understanding the application of concepts.',
      attendancePolicy: 'Compulsory (attendance taken)',
      weightageDistribution: 'Quizzes: 15%, Assignments: 15%, Midsem: 30%, Endsem: 40%',
      improvements: 'Providing a formula sheet in exams would be helpful given the number of equations.',
    },
    {
      id: 2005, // New ID
      studentName: 'Rohan Verma',
      yearOfStudy: 'Fourth Year',
      courseName: 'AE 405 - Propulsion',
      courseCode: 'AE 405',
      semester: 'Spring 2025',
      instructor: 'Dr. Sudarshan Kumar',
      difficulty: 4,
      difficultyAspects: ['Concept heavy'],
      effort: 'Very good',
      instructorRatings: { teachingStyle: 5, clarity: 4, studentInterest: 5, timeManagement: 5, approachability: 5, feedback: 4, },
      contentRatings: { clarity: 4, organization: 5, workload: 'Appropriate', participation: 4, },
      quizzes: '2',
      examDifficulty: 4,
      formulaSheetPolicy: 'No',
      usefulReferences: ['Slides'],
      youtubePlaylist: '',
      assignmentFrequency: 'Bi-weekly',
      assignmentDifficulty: 4,
      assignmentBrief: 'The assignments directly reflected what was taught in class.',
      attendancePolicy: 'Compulsory (attendance taken)',
      weightageDistribution: 'Quizzes: 15%, Assignments: 15%, Midsem: 30%, Endsem: 40%',
      improvements: 'The course is great, but a bit more time on turbine analysis would be helpful.',
    },
    {
      id: 2006, // New ID
      studentName: 'Ananya Gupta',
      yearOfStudy: 'Fourth Year',
      courseName: 'AE 405 - Propulsion',
      courseCode: 'AE 405',
      semester: 'Spring 2025',
      instructor: 'Dr. Sudarshan Kumar',
      difficulty: 5,
      difficultyAspects: ['Concept heavy', 'Assignments'],
      effort: 'Excellent',
      instructorRatings: { teachingStyle: 5, clarity: 5, studentInterest: 5, timeManagement: 4, approachability: 3, feedback: 3, },
      contentRatings: { clarity: 5, organization: 5, workload: 'Appropriate', participation: 5, },
      quizzes: '>3',
      examDifficulty: 5,
      formulaSheetPolicy: 'No',
      usefulReferences: ['Slides', 'PYQs', 'Reference books'],
      youtubePlaylist: 'A good series on jet engines from a pilot\'s perspective.',
      assignmentFrequency: 'Bi-weekly',
      assignmentDifficulty: 5,
      assignmentBrief: 'Very challenging assignments, start early!',
      attendancePolicy: 'Compulsory (attendance taken)',
      weightageDistribution: 'Quizzes: 15%, Assignments: 15%, Midsem: 30%, Endsem: 40%',
      improvements: 'Professor could be a bit more approachable for doubts outside of class hours.',
    },
  ];
  